
export default {
  init() {
    this.$jobs = document.querySelectorAll('.js-job');
    this.$jobButtons = document.querySelectorAll('.js-job-filter a');
    this.bindEvents();
    const urlParams = new URLSearchParams(window.location.search);
    const filter = urlParams.get('filter');
    if (filter) {
      document.querySelector(`a[data-filter="${filter}"]`).click();
    }
  },

  bindEvents() {
    this.$jobButtons.forEach($button => {
      $button.addEventListener('click', this.handleJobFilter.bind(this));
    });
  },

  handleJobFilter(event) {
    const $button = event.target;
    const filter = $button.getAttribute('data-filter');
    this.$jobButtons.forEach($button => {
      $button.classList.remove('button--secondary');
      $button.classList.add('btn-grey');
    });
    $button.classList.add('button--secondary');
    $button.classList.remove('btn-grey');
    this.filterJobs(filter);
    if (filter === 'all') {
      history.pushState(null, null, window.location.pathname);
    } else {
      history.pushState(null, null, `?filter=${filter}`);
    }
    event.preventDefault();
  },

  filterJobs(filter) {
    this.$jobs.forEach($job => {
      const jobLocation = $job.dataset.location;
      if (filter === 'all' || filter === jobLocation) {
        $job.classList.remove('u-hidden-visually');
      } else {
        $job.classList.add('u-hidden-visually');
      }
    });
  },
};
